// const prefix = 'https://pro-ficiency-static.s3.us-east-2.amazonaws.com/visits/';
const prefix = 'https://d2jth2langi9vb.cloudfront.net/visits/';

const videoUtils = {

  returnVideoSources(videoUrl, posterUrl, tracks, id) {
    // setup our variables
    let videoSources = [];
    let extensionIndex;
    let videoType;
    let videoObj = {};
    const videoExtentions = ['webm', 'mp4'];
    // const videoExtentions = ['mp4', 'webm'];

    // create our video object
    if(videoUrl) {
      extensionIndex = videoUrl.lastIndexOf(".");
      videoType = videoUrl.substring(extensionIndex + 1);
    }

    videoObj.key = id+videoType;
    // videoObj.type = videoExtentions[0];
    videoObj.posterUrl = posterUrl;

    // create multiple sources for fallback
    let sources = [];
    videoExtentions.map((ext) => {
      // console.log(videoUrl);
      let sourceFile = {};
      sourceFile.file = videoUrl ? videoUrl.substring(0, videoUrl.lastIndexOf(".")) + "." + ext : '';
      sourceFile.type = ext;
      sources.push(sourceFile);
    });
    videoObj.sources = sources;
    // console.log(sources);
    if(tracks) {
      videoObj.tracks = [];
      tracks.map((track) => {
        let tracksObj = {};
        tracksObj.file = '/api/scenes/static?url=' + track.file;
        tracksObj.label = track.label;
        tracksObj.kind = 'captions';
        videoObj.tracks.push(tracksObj);
      });
    }
    // console.log(videoObj);
    videoSources.push(videoObj);
    // console.log("RETURN VIDEO SOURCES", videoSources);

    // return our video sources array of objects
    return videoSources;

  }

  , returnPlaylist(videoPath, imagePath, tracks) {
    const path = videoPath ? videoPath.substring(videoPath.lastIndexOf('.'), 0) : null;
    if(!videoPath) {
      return null;
    } else {

      // console.log("testing")
      // console.log(prefix + path + '.mp4')

      return [{
        image: imagePath ? prefix + imagePath : null
        , sources: [
          {
            default: false
            , file: prefix + path + '.webm'
            , label: '0'
            , type: 'webm'
          }
          , {
            default: false
            , file: prefix + path + '.mp4'
            , label: '0'
            , type: 'mp4'
          }
        ]
        , tracks: tracks ? tracks.map(track => {
          return {
            ...track
            , file: '/api/scenes/static?url=' + track.file
          }
        }) : []
      }]
    }

  }
  , returnPosterUrl(posterPath) {
    return prefix + posterPath;
  }
}

export default videoUtils;



// WEBPACK FOOTER //
// global/utils/videoUtils.js